import React from 'react';
import ReportingStaffingReportPage from '../components/ReportingStaffingReportPage';

const ReportingStaffingReportApp = (props) => (
  <ReportingStaffingReportPage {...props} />
);

export default ReportingStaffingReportApp;
